import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registrationActions from '../../../actions/registration';

class Help extends React.Component {
  componentDidMount() {
    this.props._registration.updateProperty('access_code', 'Screen1');
  }

  render() {
    return <div className="columns">
      <div className="column"></div>
      <div className="column content">
        Curious if you (or loved one) have a bipolar diagnosis and are looking for help?<br/>
        Get the help and support you need using this free access code:
      </div>
      <div className="column"></div>
    </div>;
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _registration: bindActionCreators(registrationActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Help);



// WEBPACK FOOTER //
// ./src/components/pages/landing/Help.js